// store/modules/im/index.js
import { state, mutations, getters } from './im'
import imActions from '../../actions/imActions'
import friendActions from '../../actions/friendActions'
import msgActions from '../../actions/msgActions'
import msgHandler from '../../actions/msgHandler'

const actions = {
    ...imActions,
    ...friendActions,
    ...msgActions,
    ...msgHandler
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}